import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

function ColorBubbles({ colors }) {
  return (
    <Fragment>
      {colors.map((color) => (
        <div className="color-bubble" style={{ backgroundColor: `${color}` }} key={color} />
      ))}
    </Fragment>
  )
}

ColorBubbles.propTypes = {
  colors: PropTypes.arrayOf(PropTypes.string).isRequired,
}

export default ColorBubbles
